import { action, observable } from 'mobx'
import Api from '@api/xiao_xiong/notice'
import { message, Modal } from 'hljd'
import { isObj } from '@hlj/hlj-utils'
import { REALNAME_AUTH_PATH_A } from '@constant'
import { getMerchantInfo, HLJ_STATISTIC, isHotelMerchant } from '@util'
import { notify_type } from './config'
import {
  goZgt,
  goZgtRechargeDetail
} from '@components/LocalMerchant/ZhiGuangTong/util'

class Store {
  /**
   * 分页信息
   */
  @observable
  pagination = {
    //分页信息
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 20,
    total: 0
  }

  @action
  paginationChange = (current, pageSize) => {
    this.pagination.current = current
    this.pagination.pageSize = pageSize
    this.getNoticeList(current)
  }

  /**
   *
   * 菜单类别
   */
  @observable
  selectTab = notify_type
    .filter(item => !item.hidden)
    .find(item => item.isDefault).id

  @action
  changeSelectTab = type => () => {
    this.selectTab = type // 发券助手  type === 19
    this.readStatus = ''
    this.getNoticeList(1)
  }

  /**
   * 全部 or 未读 列表
   */
  @observable readStatus = '' // 默认为全部''  '0'为未读 2
  @action
  onChangeStatus = e => {
    this.readStatus = e.target.value
    this.getNoticeList(1)
  }

  /**
   * 获取通知列表
   */
  @observable noticeList = []
  @observable isLoading = false

  getNoticeList = async (page = this.pagination.current) => {
    let params = {
      notify_type: this.selectTab,
      per_page: this.pagination.pageSize,
      status: this.readStatus,
      page
    }
    this.isLoading = true
    const {
      data: { list, total_count = 0 }
    } = await Api.getNoticeListApi(params)
    this.pagination.total = +total_count
    this.pagination.current = page
    this.noticeList = list || []
    this.isLoading = false
  }

  /**
   * 获取未读条数
   */
  @observable unreadObj = {}
  @action
  getUnread = async () => {
    const { data } = await Api.getUnreadApi()
    this.unreadObj = data || {}
  }

  /**
   * 获取通知名称
   */
  getNoticeName = (notify_type, entity, record) => {
    let style = notify_type == '10' ? '17' : notify_type
    let obj = { name: '', style: `notice_${style}` }
    switch (String(notify_type)) {
      case '2':
        obj.name = '订单消息'
        break
      case '3':
        entity == 'MarketingActivityMeal'
          ? (obj.name = '活动报名')
          : (obj.name = '活动助手')
        break
      case '4':
        obj.name = '预约消息'
        break
      case '6':
        obj.name = '营收消息'
        break
      case '16':
        obj.name = '评价助手'
        break
      case '17':
      case '10':
        obj.name = '互动消息'
        if (entity === 'QaQuestion') {
          // 特殊处理
          obj.name = record.participant_name
          obj.icon = true
        }
        break
      case '19':
        obj.name = '发券助手'
        break
      case '34':
        obj.name = '广告计划异常提醒'
        obj.style = 'notice_others'
        break
      default:
        obj.name = '系统消息'
        obj.style = 'notice_others'
    }
    return obj
  }

  /**
   * 通知列表数据转换相关函数
   */
  getMessage = item => {
    const { notify_type, action, content, extra_objects = {} } = item
    let cont = ''
    let ct = ''
    let grade = ''
    let merInfo
    let type = String(notify_type)
    switch (type) {
      //1=>"社区通知",2=>"订单小精灵",3=>"婚礼纪活动",4=>"预约小助手",5=>"评论",6=>"收入小管家",7=>"审核小秘书"
      case '9':
        if (action != 'merchant_notify_text') {
          let _json = JSON.parse(content || null)
          if (action == 'merchant_notify_feature') {
            if (_json.target_type == '100') {
              merInfo = getMerchantInfo()
              grade = merInfo.grade.grade_level
            }
          }
        }
        break
    }
    if (action == 'audit_success' || action == 'audit_fail') {
      ct = extra_objects.set_meal.commodity_type
    }
    if (content) {
      cont = content
    }
    return { cont, ct, grade }
  }

  // 已优化
  goto = (item, messageObj, link) => {
    const { action, entity_id, entity } = item

    this.readNotice(item)
    if (entity == 'MerchantNotification') {
      HLJ_STATISTIC({
        event_type: 'element_hit',
        data_type: 'Merchant_Notepush',
        data_id: entity_id,
        page_name: '消息列表/首页'
      })
    }

    // 如果是酒店商家
    if (action === 'hotel_merchant_task' && isHotelMerchant()) {
      return Modal.info({
        title: '提示',
        content: '请到商家app端查看详情'
      })
    }

    // 奖励金
    if (action === 'bounty_tips') {
      goZgt()
      return
    }
    if (action === 'cpm_coupon_tips') {
      goZgtRechargeDetail()
      return
    }

    // 活动报名
    const openWindowActions = [
      'update_marketing_meal_status',
      'marketing_activity_meal_examine',
      'marketing_activity_examine',
      'live_channel_report_examine', // 直播提报单
      'live_channel_examine_success', // 审核通过
      'live_channel_examine_fail', // 审核不通过
      'live_start', // 直播开始
      'live_self_end', // 直播自动结束
      'live_flow_limit', // 直播限流
      'merchant_material_notify', // 创意中心
      'cpt_set_meal_schedule_add',
      'collect_case',
      'forwarding_case',
      'appeal_success',
      'appeal_failed'
    ]
    if (openWindowActions.includes(action) && !!link) {
      return window.open(link)
    }
    const checkCommentActions = [
      'proof_from_user',
      'appeal_success_to_merchant',
      'appeal_fail_to_merchant',
      'order_comment_review_pass',
      'order_comment_merchant',
      'order_comment_review_reply_merchant'
    ]
    if (checkCommentActions.includes(action)) {
      if (
        action == 'order_comment_merchant' ||
        action == 'order_comment_review_reply_merchant'
      ) {
        let realId = item.body == '回复了你' ? item.parent_entity_id : entity_id
        this.checkComment(realId, () => window.open(link))
      } else {
        this.checkComment(entity_id, () => (window.location.href = link))
      }
      return
    }

    if (messageObj.grade == '0') {
      return message.warning('您还属于0级，无法查看')
    }

    if (!!link) {
      switch (action) {
        case 'audit_success':
          if (messageObj.ct == '0' || messageObj.ct == '1') {
            window.open(link)
          }
          break
        case 'audit_fail':
          window.open(link)
          break
        case 'ad_poor_merchant': //商家广告余额不足
          goZgtRechargeDetail()
          break
        case 'bd_merchant_order': //支付通知跳转到订单详情
          this.checkOrderStatus(entity_id)
          break
        case 'open_trade_fail': //企业实名认证失败
          this.checkOpenTrade()
          break
        case 'test_store_send_order': //体验店推荐通知跳转
          this.checkStoreStatus(entity_id)
          break
        case 'store_merchant_remark': //体验店推荐
          this.checkStoreStatus(entity_id)
          break
        default:
          window.location.href = link
      }
    }
  }
  checkOpenTrade = async () => {
    const { success, data } = await Api.checkCertifyApi()
    const { status } = data || {}
    if (success) {
      if (status == 3) {
        window.open('#/localMerchant/home')
      } else {
        window.open(REALNAME_AUTH_PATH_A)
      }
    }
  }

  checkComment = async (_realId, redirect) => {
    const { data } = await Api.checkCommentApi({ id: _realId })
    let response = data || {}
    if (response.res == 1) {
      message.warning('该评价已经删除~')
    } else {
      redirect()
    }
  }

  checkOrderStatus = async _id => {
    // 支付订单状态获取
    const { data, success } = await Api.checkOrderStatusApi({ id: _id })
    if (success) {
      let response = data || {}
      if (response.status == 3) {
        message.warning('订单审批中')
      } else if (response.status == 4) {
        message.warning('订单审批拒绝')
      } else {
        window.open(
          '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/marketingCenter/paymentDetail?id=' +
            _id
        )
      }
    }
  }

  checkStoreStatus = async _id => {
    const { data, success } = await Api.checkStoreStatusApi({ id: _id })
    if (success) {
      let response = data || {}
      if (response.status == 2) {
        message.warning('推荐已过期，请联系体验店工作人员')
      } else {
        window.open(`#/localMerchant/experienceShop/detail/${_id}`)
      }
    }
  }

  @action
  readNotice = async param => {
    let params
    let unreadNum = this.unreadObj[this.selectTab]
      ? Number(this.unreadObj[this.selectTab])
      : 0
    if (isObj(param) && param.id) {
      if (param.status == '2') {
        return
      }
      params = { id: param.id }
    } else {
      if (unreadNum == 0) {
        return
      }
      params = { notify_type: this.selectTab }
    }
    const { success } = await Api.readNoticeApi(params)
    if (success) {
      this.getUnread()
      this.getNoticeList()
    }
  }
}

export default Store
